import { render, staticRenderFns } from "./GrpTargetSelect.vue?vue&type=template&id=4bad84c6&"
import script from "./GrpTargetSelect.vue?vue&type=script&lang=ts&"
export * from "./GrpTargetSelect.vue?vue&type=script&lang=ts&"
import style0 from "./GrpTargetSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports